import { horizontalLoop } from "./utils";
const circleSliderSections = document.querySelectorAll(
  ".circle-slider-section"
);

// Function to check if screen is mobile
function isMobile() {
  return window.innerWidth < 768;
}

circleSliderSections.forEach((sliderSection, i) => {
  const slides = sliderSection.querySelectorAll(".circle-slide");
  const prev = sliderSection.querySelector(".prev");
  const next = sliderSection.querySelector(".next");
  const prevMobile = sliderSection.querySelector(".prev-mobile");
  const nextMobile = sliderSection.querySelector(".next-mobile");

  let currentIdx = 0;
  const totalSlides = slides.length;
  let autoSlideInterval;
  
  function nextSlide() {
    if (currentIdx < totalSlides - 1) {
      currentIdx = currentIdx + 1;
      updateSlides();
    }
  }

  function prevSlide() {
    if (currentIdx > 0) {
      currentIdx = currentIdx - 1;
      updateSlides();
    }
  }

  function startAutoSlide() {
    // Clear any existing interval
    if (autoSlideInterval) {
      clearInterval(autoSlideInterval);
    }
    // Start new interval - advance every 4 seconds, but stop if we reach the end
    autoSlideInterval = setInterval(() => {
      if (currentIdx < totalSlides - 1) {
        nextSlide();
      } else {
        // Stop auto-slide when we reach the end
        stopAutoSlide();
      }
    }, 4000);
  }

  function stopAutoSlide() {
    if (autoSlideInterval) {
      clearInterval(autoSlideInterval);
      autoSlideInterval = null;
    }
  }

  function updateButtonStates() {
    // Update prev buttons - disabled when currentIdx is 0
    if (prev) {
      prev.disabled = currentIdx === 0;
    }
    if (prevMobile) {
      prevMobile.disabled = currentIdx === 0;
    }
    
    // Update next buttons - disabled when currentIdx is at the last slide
    if (next) {
      next.disabled = currentIdx === totalSlides - 1;
    }
    if (nextMobile) {
      nextMobile.disabled = currentIdx === totalSlides - 1;
    }
  }

  function updateSlides() {
    const isMobileView = isMobile();
    const spacing = 136; // Same spacing for both orientations
    
    slides.forEach((slide, index) => {
      const offset = index - currentIdx;
      
      if (isMobileView) {
        // Vertical layout for mobile
        slide.style.transform = `translateY(${offset * spacing}px)`;
      } else {
        // Horizontal layout for desktop
        slide.style.transform = `translateX(${offset * spacing}px)`;
      }
      
      slide.style.zIndex = totalSlides - Math.abs(offset);
      slide.style.opacity = Math.abs(offset) > 2 ? 0 : 1;
      
      // Hide h4 and p elements except on the front circle (offset 0)
      const h4Element = slide.querySelector('h4');
      const pElement = slide.querySelector('p');
      
      if (h4Element) {
        h4Element.style.display = offset === 0 ? 'block' : 'none';
      }
      if (pElement) {
        pElement.style.display = offset === 0 ? 'block' : 'none';
      }
    });
    
    // Update button states after updating slides
    updateButtonStates();
  }

  // Handle window resize
  function handleResize() {
    updateSlides();
  }

  // Add event listeners for both desktop and mobile controls
  if (prev) {
    prev.addEventListener("click", () => {
      stopAutoSlide();
      prevSlide();
      // Restart auto-slide after 6 seconds of inactivity
      setTimeout(startAutoSlide, 6000);
    });
  }
  if (next) {
    next.addEventListener("click", () => {
      stopAutoSlide();
      nextSlide();
      // Restart auto-slide after 6 seconds of inactivity
      setTimeout(startAutoSlide, 6000);
    });
  }
  if (prevMobile) {
    prevMobile.addEventListener("click", () => {
      stopAutoSlide();
      prevSlide();
      // Restart auto-slide after 6 seconds of inactivity
      setTimeout(startAutoSlide, 6000);
    });
  }
  if (nextMobile) {
    nextMobile.addEventListener("click", () => {
      stopAutoSlide();
      nextSlide();
      // Restart auto-slide after 6 seconds of inactivity
      setTimeout(startAutoSlide, 6000);
    });
  }
  
  window.addEventListener("resize", handleResize);
  updateSlides();
  
  // Start auto-slide when the slider is initialized
  startAutoSlide();
});
